module.exports = __webpack_public_path__ + "img/asia-admin04.9a5c77c0.png";